var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTradingPause = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    fillRule: "evenodd",
    d: "M12 3.875A8.125 8.125 0 0 0 3.875 12 8.125 8.125 0 0 0 12 20.125 8.125 8.125 0 0 0 20.125 12 8.125 8.125 0 0 0 12 3.875M12.625 7a.625.625 0 1 0-1.25 0v5c0 .345.28.625.625.625h3.75a.624.624 0 1 0 0-1.25h-3.125z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB241",
    d: "M23 18a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.304 18.384v-3.075h1.392v3.075zM17.304 20.542V19.15h1.392v1.392z",
    clipRule: "evenodd"
  })));
};
export default SvgTradingPause;